Ext.define('SA.BalancedTextWrapper', {
    constructor() {
        var container = this.container = SA.Html.createEl('div'),
            span = this.span = SA.Html.createEl('span');

        container.append(span);

        SA.HiddenDom.attach(container);
    },

    getWidth({text, maxWidth, styles}) {
        this.setMaxWidth(maxWidth);
        this.span.textContent = text;

        SA.Html.applyStyles(this.span, styles);

        var results = [],
            minLineCount = Array.from(this.span.getClientRects()).length,
            decrement = 5; 

        for (let width = maxWidth; width > 0; width -= decrement) {
            this.setMaxWidth(width);

            let rects = Array.from(this.span.getClientRects()),
                lineCount = rects.length,
                deviation = SA.Math.standardDeviation(rects.map(rect => rect.width));

            if (lineCount > minLineCount) {
                break;
            }

            results.push({width, deviation, lineCount});
        }

        return results.reduce((a, b) => b.deviation < a.deviation ? b : a).width;
    },

    setMaxWidth(maxWidth) {
        this.container.style.maxWidth = maxWidth + 'px';
    }
});